import type {DoppeViewerClientServices} from "../../doppe-user-app/doppe-viewer-client-services";
import {DoppeViewerHeadlessTokensCookieName} from "../../../client-server-common";
import type {WixSdkMember, WixSdkTokens} from "../../doppe-viewer-headless-sdk/doppe-viewer-headless-sdk.types";

export async function doppeViewerGetCurrentMember (clientServices: DoppeViewerClientServices) : Promise<WixSdkMember | undefined> {

    const {
        doppeViewerHeadlessSdkGetCurrentMember,
    } = await import('../../doppe-viewer-headless-sdk/doppe-viewer-headless-sdk-members.dynamic');

    return doppeViewerHeadlessSdkGetCurrentMember({
        clientId: clientServices.headlessService.assertClientId(),
        tokens: doppeViewerGetHeadlessToken(clientServices),
    });

}

export function doppeViewerGetHeadlessToken (clientServices: DoppeViewerClientServices) : WixSdkTokens | null {

    const cookieAccessor = clientServices.doppeViewerAppCookieService.consentSafeCookieStorageAccessor;

    return cookieAccessor?.getItem(DoppeViewerHeadlessTokensCookieName) ?? null;
}